module.exports = __webpack_public_path__ + "facelifting_6_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/facelifting_6_before_tn.jpg
// module id = 1528
// module chunks = 0